import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Copy, Forms, Modal, SaveButton, SystemText } from 'e4shared';
import { setPickerFilters, toggleFormHelp } from 'actions/ui';
import { ModalPicker } from 'components/user/modalPicker';

export const ProfileGroupModal = ({ show, close, onSave, users, mode, profileGroup, collections }) => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user.user);
    const [hasUsersSelected, setHasUsersSelected] = React.useState(false);
    const [tab, setTab] = React.useState('assign');    

    const emptyProfileGroup = {
        id: 0,
        name: '',
        collectionIds: [],
        canOverrideProfiles: true
    };

    const isRichardsonAdministrator = user.authority === 'PARTNER';

    const [formProfileGroup, setFormProfileGroup] = useState(emptyProfileGroup);

    const defaultValues = useMemo(() => {
        return {
            ids: [],
        };
    }, []);

    const [saving, setSaving] = useState(false);
    const [errors, setErrors] = useState({});
    const [selected, setSelected] = useState([]);
    const [values, setValues] = useState(defaultValues);

    useEffect(() => {
        if (mode === 'edit' && profileGroup) {
        
            setFormProfileGroup({ ...profileGroup });

            setValues({
                ids: profileGroup.profileGroupProfiles?.map(p => p.profileId) || []
            });
        }
        else if (mode === 'add') {
            setFormProfileGroup({ ...emptyProfileGroup });
            setValues({ ids: [] });
        }
    }, [mode, profileGroup]);

    useEffect(() => {
        if (values?.ids) {
            const temp = users.filter(u => values.ids.some(x => x === u.id));
            setSelected(temp);            
        }
    }, [values?.ids]);

    React.useEffect(() => {
        const extra = selected.some(x => !x.disabled);
        setHasUsersSelected(extra);
    }, [selected]);

    const validate = profileGroup => {
        let result = true;
        const theseErrors = {};

        return result;
    };

    const save = () => {
        if (validate(values)) {

            onSave({
                ...formProfileGroup,
                includeProfileIds: values?.ids || []
                });

            closeModal();            
        }

        setSaving(false);
    };

    const closeModal = () => {
        setErrors({});
        close?.();
        setSaving(false);        
        dispatch(setPickerFilters([]));
    };

    const setValue = (property, value) => {
        const temp = { ...values };
        temp[property] = value;
        setValues(temp);
    };

    const footer = React.useMemo(
        () => (
            <div>
                <button data-testid="cancel-button" className="btn" 
                onClick={() => {
                    setFormProfileGroup(prev => ({
                        ...prev,
                        name: '',
                        profileGroupProfiles : []
                    }));
                    closeModal(true);
                }}>
                    {SystemText('General/Buttons/Cancel')}
                </button>
              
                <SaveButton
                    data-testid="save-button"
                    saving={saving}
                    setSaving={setSaving}
                    className="btn btn-success"
                    onClick={() => {
                        save({values});
                    }}
                >
                    {
                    mode === 'add'
                    ? SystemText('Admin/UserGroup/Modal/AddNewGroup')
                    : SystemText('Admin/UserGroup/Modal/SaveGroup')
                    }
                </SaveButton>                                
            </div>
        ),
        [tab, hasUsersSelected, values, formProfileGroup]
    );    

    return (
        <Modal
            data-testid="post-modal"
            show={show}
            close={closeModal}
            footer={footer}
            toggleFormHelp={() => dispatch(toggleFormHelp())}
            className="modal-body-full modal-920"
            title={
                mode === 'add'
                    ? SystemText('Admin/UserGroup/Modal/Title/Add')
                    : SystemText('Admin/UserGroup/Modal/Title/Edit')
            }        
            iconsPre    
        >
            {tab === 'assign' ? (
                <div>                
                    <Forms.Text
                        id="profileGroupNameId"
                        label={SystemText('Admin/UserGroup/Fields/Name')}                        
                        placeholder={SystemText('Admin/UserGroup/Fields/Name/Placeholder')}                        
                        value={formProfileGroup.name}
                        onChange={value =>
                            setFormProfileGroup(prev => ({
                            ...prev,
                            name: value
                            }))
                        }
                        mandatory
                    />
                             
                {isRichardsonAdministrator &&
                    <Forms.Select
                        id="collectionIds"
                        allowMultiple
                        data={collections.map(c => ({ id: c.id, name: c.name }))}
                        label={SystemText('Admin/UserGroup/Fields/AssignCollection')}                        
                        placeholder={SystemText('Admin/UserGroup/Fields/AssignCollection/Placeholder')}
                        value={(formProfileGroup.collectionIds)}
                        onChange={ids =>
                            setFormProfileGroup(prev => ({
                                ...prev,
                                collectionIds:ids
                            }))
                        }
                    />
                }
            
                {formProfileGroup.canOverrideProfiles === true && (
    <ModalPicker
        value={values?.ids}
        disabledUsers={[]}
        onChange={ids => setValue('ids', ids)}
    />
)}

{formProfileGroup.canOverrideProfiles !== true && (
    <div className="info-message">
        {SystemText('Admin/UserGroup/Modal/AllUsers/UsersReadOnly')}
    </div>
)}
                </div>
            ) : (
                <div>                    
                    <div className="mb20 mt20 flex flex-center">
                        <i className="fa fa-warning fa-lg mr10 text-danger" />
                        <span className="flex-grow">
                            <Copy value={SystemText('Admin/UserGroup/Modal/NoUsers')} />
                        </span>
                    </div>                    
                </div>
            )}
        </Modal>
    );
};

export default ProfileGroupModal;